<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #dt
          [columns]="scrollableCols"
          [value]="eventsDisplayed"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          scrollHeight="550px"
          dataKey="m365eventId"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          [totalRecords]="totalRecords"
          [lazy]="true"
          (onLazyLoad)="this.loadEvents($any($event))"
          (onFilter)="applyFilter($event)"
          exportFilename="M365EventRecords">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <input
                type="text"
                pInputText
                size="30"
                placeholder="Search"
                (keyup)="
                  eventSearchFilterRequest.searchString = $any(
                    $event.currentTarget
                  ).value
                "
                [(ngModel)]="eventSearchFilterRequest.searchString"
                (input)="onSearchInput($event, dt)"
                style="width: auto"
                [value]="
                  dt.filters['global'] ? $any(dt.filters['global']).value : ''
                " />
              <i class="fa fa-search ml-2"></i>
              <span class="pageInfo visiblelg resettble">{{
                currentPageInfo
              }}</span>
              <span style="float: right"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header>
            <tr class="row">
              <th
                [pSortableColumn]="'eventKey'"
                (click)="sort('eventKey')"
                class="colxs">
                Engagement ID<p-sortIcon [field]="'eventKey'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'eventId'" class="colxs">Preview</th>
              <th
                [pSortableColumn]="'eventName'"
                (click)="sort('eventName')"
                class="collarge">
                Engagement Sub Type<p-sortIcon
                  [field]="'eventName'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'partnerOrgName'"
                (click)="sort('partnerOrgName')"
                class="colsmall">
                Partner Org<p-sortIcon [field]="'partnerOrgName'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'customerOrgName'"
                (click)="sort('customerOrgName')"
                class="colsmall">
                Customer Org<p-sortIcon
                  [field]="'customerOrgName'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'customerCountry'"
                (click)="sort('customerCountry')"
                class="colsmall">
                Customer Country<p-sortIcon
                  [field]="'customerCountry'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'fiscalYear'"
                (click)="sort('fiscalYear')"
                class="colxs">
                Fiscal Year<p-sortIcon [field]="'fiscalYear'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'l1InternalStatus'"
                (click)="sort('l1InternalStatus')"
                class="colsmall">
                L1 Internal Status<p-sortIcon
                  [field]="'l1InternalStatus'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'l2InternalStatus'"
                (click)="sort('l2InternalStatus')"
                class="colsmall">
                L2 Internal Status<p-sortIcon
                  [field]="'l2InternalStatus'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'poeDocUploadDate'"
                (click)="sort('poeDocUploadDate')"
                class="colsmall">
                Uploaded Date<p-sortIcon
                  [field]="'poeDocUploadDate'"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            <tr
              (dblclick)="editRequestDetails(rowData.eventRegistrationId)"
              class="row">
              <td class="colxs">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }}">
                  <a
                    (click)="editRequestDetails(rowData.eventRegistrationId)"
                    class="editlink"
                    (keydown.enter)="
                      editRequestDetails(rowData.eventRegistrationId)
                    "
                    tabindex="0"
                    >{{ rowData.eventRegistrationId }}</a
                  >
                </span>
              </td>
              <td class="colxs">
                @if (rowData.isDisablePreview) {
                  <span> Preview </span>
                }
                @if (!rowData.isDisablePreview) {
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.eventRegistrationId }} : {{
                      rowData.eventRegistrationId
                    }}">
                    <a
                      class="editlink"
                      (click)="previewFile(rowData.eventRegistrationId)"
                      (keydown.enter)="previewFile(rowData.eventRegistrationId)"
                      tabindex="0"
                      >Preview</a
                    >
                  </span>
                }
              </td>
              <td class="collarge">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.eventName
                  }}"
                  >{{ rowData.eventName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.partnerOrgName
                  }}"
                  >{{ rowData.partnerOrgName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    getCustomerName(rowData)
                  }}"
                  >{{ getCustomerName(rowData) }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    getCustomerCountry(rowData)
                  }}"
                  >{{ getCustomerCountry(rowData) }}</span
                >
              </td>
              <td class="colxs">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.fiscalYear
                  }}"
                  >{{ rowData.fiscalYear }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.l1InternalStatusName
                  }}"
                  >{{ rowData.l1InternalStatusName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.l2InternalStatusName
                  }}"
                  >{{ rowData.l2InternalStatusName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    getUploadedDate(rowData)
                  }}"
                  >{{ getUploadedDate(rowData) }}</span
                >
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

@if (loadEditComponent) {
  <p-dialog
    id="engagementEdit"
    [transitionOptions]="'10ms'"
    [(visible)]="editNav"
    modal="true"
    showEffect="fade"
    [maximizable]="true"
    [style]="{ width: '90vw' }"
    (onHide)="onCloseEditModal()"
    [draggable]="false"
    [resizable]="false">
    <app-edit-event
      [eventRegistrationId]="eventEditInput.eventRegistrationId"
      [programTypeGUID]="mrppProgram"
      #editNavChild
      (showFullscreen)="onShowFullScreenChanged($event)"
      (closeEditSidebar)="onCloseEditModal()"></app-edit-event>
  </p-dialog>
}

@if (canShowMrppPreviewModel) {
  <app-mrpp-preview
    (reLoadList)="refresh()"
    [mrppPreviewInput]="mrppPreviewInput"
    (closePreviewModal)="closePreview()">
  </app-mrpp-preview>
}
